export default __webpack_public_path__ + "static/media/slide9.a0723e9c.jpg";